// src/components/Marketplace/Amazon/Error/ErrorPage.jsx

import React from 'react';

const ErrorPage = ({ message, onRetry }) => {
  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg"
          alt="Amazon"
          style={styles.logo}
        />
        <h2 style={styles.title}>Amazon Connection Error</h2>
        <p style={styles.message}>{message}</p>
        <button onClick={onRetry} style={styles.button}>Retry</button>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'calc(100vh - 80px)', // Adjust as needed
    backgroundColor: '#f5f5f5',
    padding: '20px',
  },
  card: {
    maxWidth: '500px',
    width: '100%',
    backgroundColor: '#fff',
    borderRadius: '12px',
    padding: '40px 30px',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
  },
  logo: {
    width: '150px',
    marginBottom: '20px',
  },
  title: {
    fontSize: '22px',
    marginBottom: '10px',
    color: '#333',
  },
  message: {
    fontSize: '16px',
    marginBottom: '20px',
    color: '#d93025',
  },
  button: {
    backgroundColor: '#ff9900',
    color: '#fff',
    border: 'none',
    padding: '10px 20px',
    fontSize: '16px',
    borderRadius: '6px',
    cursor: 'pointer',
  },
};

export default ErrorPage;
